/**
 * @ngdoc directive
 * @name cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
 * @restrict E
 * @description Componente che racchiude al suo interno il wizard per la gestione delle raccomandazioni
 * @param {String} nuovaPropostaState - Nome dello stato su cui navigare quando si vuole creare una nuova proposta
 * @param {String} modificaPropostaState - Nome dello stato su cui navigare quando si vuole modificare una proposta
 * @param {String} gestioneRichiestaState - Nome dello stato per la gestione di una richiesta
 * @param {String} saldoDossierState - Nome dello stato per il saldo del dossier
 * @param {String} modalita - Modalità di ingresso nella gestione di una raccomandazione, valori possibili:
 * 'VISUALIZZA', 'MODIFICA', 'NUOVA' e 'VALUTAZIONE'
 */
(function () {
  'use strict';
  var GestioneRaccomandazioneCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $location,
    $uibModal,
    messaggiFctr,
    labelSrvc,
    CONSTANTS,
    $window,
    gestioneRaccomandazioneService,
    uiGridConstants,
    userSrvc,
    messaggiSrvc,
    brioSrvc,
    deskSrvc
  ) {
    this.$http = $http;
    this.$window = $window;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.CONSTANTS = CONSTANTS;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.userSrvc = userSrvc;
    this.brioSrvc = brioSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.deskSrvc = deskSrvc;

    this.idRichiestaOrdineDiretto;
    this.idRaccomandazioneOrdineDiretto;
    this.ordineDiviso = [];
    this.ordineDivisoTableLabel = [];
    this.posizione = {};
    this.dettaglioDossier = {};
    this.currentTabMacro = {};
    this.raccomandazione = {};
    this.iniziativa = undefined;
    this.profiloCliente = {};
    this.proposteTableData = [];
    this.proposteTableLabel = [];
    this.portafoglioTableData = [];
    this.portafoglioTableLabel = [];
    this.listaRegoleStrumento = [];
    this.totaleCtvTeorico = 0;
    this.dossierAbilitato = undefined;
    this.homeBankingAbilitato = false;
    this.anagraficaFea = {};
    this.esgAbilitato = false;
    this.tmpLiquiditaAggiuntiva = 0;
    this.liquiditaAggiuntiva = 0;
    this.attivaLiquiditaAggiuntiva = false;
    this.domain = {
      listaTipologiaStrumento: []
    };
    this.spinner = {
      portafoglio: true,
      proposte: true,
      raccomandazione: true,
      listaDossier: false,
      adeguatezza: true,
      ba: true
    };
    this.richiestaProcessione = 'S';
    this.regexTestoNota = new RegExp(!/^[a-zA-Z \u00E0-\u00FC'0-9,.;:]+$/i);
    this.scontoMassivo = false;
    this.segnalazioni = {};

    this.bloccoAcquisti = false;
    this.waitUser = true;
    this.messaggiFctr.chiudiLoaderBrio();
    var self = this;

    this.mifidAbilitato = function () {
      return userSrvc.abilitazioni.some(function (abilitazione) {
        return (
          abilitazione.codice.toLowerCase() ===
          CONSTANTS.ABILITAZIONI.MIFID.toLowerCase()
        );
      });
    };

    userSrvc.abilitazioniPronte.then(function () {
      self.esgAbilitato = userSrvc.abilitato(
        CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA
      );
      self.attivaLiquiditaAggiuntiva =
        userSrvc.liquiditaAggiuntivaAttiva &&
        self.$stateParams.finIdRaccomandazione;
    });

    labelSrvc.labelsPronte.then(function () {
      self.TAB_LIST_MACRO = [
        {
          index: 0,
          url:
            self.CONSTANTS.BASE_ROOT +
            self.CONSTANTS.COMPONENTS_PATH +
            'gestioneRaccomandazione/partials/inserimentoProposte.html',
          title: $scope.msg('step.gestione.raccomandazione')
        },
        {
          index: 1,
          url:
            self.CONSTANTS.BASE_ROOT +
            self.CONSTANTS.COMPONENTS_PATH +
            'gestioneRaccomandazione/partials/esitoRaccomandazione.html',
          title: $scope.msg('step.esito.raccomandazione')
        },
        {
          index: 2,
          url:
            self.CONSTANTS.BASE_ROOT +
            self.CONSTANTS.COMPONENTS_PATH +
            'gestioneRaccomandazione/partials/gestioneDocumenti.html',
          title: $scope.msg('step.documenti')
        },
        {
          index: 3,
          url:
            self.CONSTANTS.BASE_ROOT +
            self.CONSTANTS.COMPONENTS_PATH +
            'gestioneRaccomandazione/partials/gestioneOrdine.html',
          title: $scope.msg('step.gestioneOrdine')
        }
      ];
      //			Se provengo da Brio e non ho il codice Dossier
      if (!self.$stateParams.finCodiceRapporto) {
        self.promiseDettaglioRaccomandazione().then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.portafoglio = false;
              self.spinner.proposte = false;
              self.spinner.raccomandazione = false;
              return;
            }
            if (response.data.result && response.data.result.raccomandazione) {
              self.$stateParams.finCodiceRapporto =
                response.data.result.raccomandazione.codiceDossierTitoli;
              self.$state.go(self.$state.current.name, self.$stateParams, {
                reload: true
              });
            } else {
              self.spinner.portafoglio = false;
              self.spinner.proposte = false;
              self.spinner.raccomandazione = false;
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.portafoglio = false;
            self.spinner.proposte = false;
            self.spinner.raccomandazione = false;
          }
        );
      } else {
        // Normale funzionamento
        self.getCustomerDossier();
        if (self.$stateParams.finIdRaccomandazione) {
          self.initConIdRaccomandazione();
        } else {
          self.spinner.proposte = false;
          self.initSenzaIdRaccomandazione();
        }
      }
      self.checkAccettaRaccomandazione();
    });

    if (
      self.$stateParams.finIdRaccomandazione &&
      CONSTANTS.REST.SCONTO_MASSIVO
    ) {
      gestioneRaccomandazioneService
        .promiseAbilitaScontoMassivo(self.$stateParams.finIdRaccomandazione)
        .then(
          function (res) {
            if (self.messaggiFctr.processaResponse(res)) {
              return;
            }
            self.scontoMassivo = res.data.result;
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        );
    }
    //
    //		---------------------------- REST PROMISES ----------------------------
    //

    /**
     * @ngdoc method
     * @name promiseCustomerData
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua la chiamata per ricevere il customerdata
     * @return {Promise} - Ritorna una promise contenente il customerdata
     */
    this.promiseCustomerData = function () {
      return self.$http({
        method: 'GET',
        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
        params: {
          rapporto: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseEliminaProposta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per eliminare una proposta
     */
    this.promiseEliminaProposta = function (id) {
      return self.$http({
        method: 'DELETE',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PROPOSTA +
          'cancellaProposta/' +
          id
      });
    };

    /**
     * @ngdoc method
     * @name promiseDettaglioRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per ricevere il dettaglio di una raccomandazione
     */
    this.promiseDettaglioRaccomandazione = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRaccomandazione
      });
    };

    /**
     * @ngdoc method
     * @name promiseDominioStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
     */
    this.promiseDominioFiltriStrumento = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per ricevere la lista del portafoglio associate ad un dossier
     */
    this.promiseDatiTabellaPortafoglio = function () {
      self.spinner.listaPortafoglio = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          self.$stateParams.finCodiceRapporto +
          '/saldi'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaProposte
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per ricevere la lista delle proposte associate ad un dossier
     */
    this.promiseDatiTabellaProposte = function () {
      self.spinner.proposte = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRaccomandazione +
          '/proposte'
      });
    };

    /**
     * @ngdoc method
     * @name promiseListaDossier
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per ricevere la lista dei dossier associati ad un ndg
     */
    this.promiseListaDossier = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.DOSSIER +
          'listaDossier/' +
          self.$stateParams.ndg
      });
    };

    /**
     * @ngdoc method
     * @name promiseConsolidaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per consolidare la raccomandazione
     */
    this.promiseConsolidaRaccomandazione = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRaccomandazione +
          '/consolida'
      });
    };

    /**
     * @ngdoc method
     * @name promiseProfiloCliente
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description - Ritorna una promise contenente il profilo del cliente
     */
    this.promiseProfiloCliente = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          'profiloCliente/' +
          self.dettaglioDossier.ndgIntestatario,
        params: {
          idDossier: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseMultivariata
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description - Ritorna una promise contenente i dati della multivariata della raccomandazione
     */
    this.promiseMultivariata = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          'punteggioMultivariata',
        data: {
          ndgCliente: self.dettaglioDossier.ndgIntestatario,
          codiceRapporto: self.$stateParams.finCodiceRapporto,
          idRaccomandazione: self.$stateParams.finIdRaccomandazione,
          liquiditaAggiuntiva: self.liquiditaAggiuntiva
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseEsitoRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua la chiamata per portare la pratica in CONSOLIDATA - 2
     */
    this.promiseEsitoRaccomandazione = function () {
      return this.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRaccomandazione +
          '/esito'
      });
    };

    /**
     * @ngdoc method
     * @name promiseAccettaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per accettare la raccomandazione
     */
    this.promiseAccettaRaccomandazione = function () {
      return self.$http({
        method: 'POST',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRaccomandazione +
          '/accetta/S'
      });
    };

    /**
     * @ngdoc method
     * @name promiseRifiutaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per rifiutare la raccomandazione
     */
    this.promiseRifiutaRaccomandazione = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          'rifiuta/' +
          self.$stateParams.finIdRaccomandazione
      });
    };

    /**
     * @ngdoc method
     * @name promiseRevisionaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per mandare in revisione la raccomandazione
     */
    this.promiseRevisionaRaccomandazione = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          'revisione/' +
          self.$stateParams.finIdRaccomandazione +
          '/' +
          self.nota
      });
    };

    /**
     * @ngdoc method
     * @name promiseTerminaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per terminare la raccomandazione
     */
    this.promiseTerminaRaccomandazione = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          'termina/' +
          self.$stateParams.finIdRaccomandazione +
          '/' +
          self.richiestaProcessione
      });
    };

    /**
     * @ngdoc method
     * @name promiseDettaglioDossier
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per chiedere il dettaglio del dossier corrente
     */
    this.promiseDettaglioDossier = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.DOSSIER +
          self.$stateParams.finCodiceRapporto
      });
    };

    /**
     * @ngod method
     * @name promiseRegoleStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata http per chiedere le regole delle operazioni
     * effettuabili dall'utente sul proprio saldoPortafoglio
     */
    this.promiseRegoleStrumento = function () {
      return this.$http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'regoleStrumento'
      });
    };
    /**
     * @ngod method
     * @name promiseGestioneOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Effettua una chiamata per ottenere la proposta suddivisa per tipo
     * fondo/tuttiGliAltriTipi
     */
    this.promiseGestioneOrdine = function () {
      return this.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          'gestioneOrdine/' +
          self.$stateParams.finIdRaccomandazione +
          '/' +
          self.$stateParams.finCodiceRapporto
      });
    };
    /**
     * @ngdoc method
     * @name promiseAddLiquiditaAggiuntiva
     * @description aggiunge la liquidita aggiuntiva alla raccomandazione
     */
    this.promiseAddLiquiditaAggiuntiva = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRaccomandazione +
          '/liquiditaAggiuntiva/' +
          self.liquiditaAggiuntiva
      });
    };
    this.buttonEnabled = function () {
      self.tmpLiquiditaAggiuntiva < 0;
    };
    //
    //		-------------------------- INIT LABEL TABELLE -------------------------
    //
    /**
     * @ngdoc method
     * @name initLabelTabellaPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Crea le label e la struttura della tabella del portafoglio
     */
    this.initLabelTabellaPortafoglio = function () {
      self.portafoglioTableLabel = [
        {
          name: $scope.msg('lista.portafoglio.isin'),
          field: 'strumento.isin',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.intestatario'),
          field: 'intestatario',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.tipologia'),
          field: 'strumento.categoriaStrumento.descrizione',
          width: '*',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: self.domain.listaTipologiaStrumento
          }
        },
        {
          name: $scope.msg('lista.portafoglio.descrizione'),
          field: 'strumento.descrizione',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.divisa'),
          field: 'strumento.divisa',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.quantita.disponibile'),
          field: 'quantita',
          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
            ? 'number : 6'
            : 'number : 3',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.quantita'),
          field: 'quantita',
          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
            ? 'number : 6'
            : 'number : 3',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.ctv.euro'),
          field: 'valoreMercatoControvalore',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.rateo.netto.euro'),
          field: 'ctvRateoNettoEuro',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.rateo.lordo.euro'),
          field: 'ctvRateoLordoEuro',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.prezzo.mercato'),
          field: 'prezzoMercato',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.prezzo.medio'),
          field: 'prezzoCarico',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.plus.min'),
          // field: 'bloccoAcquisti',
          field: 'percPlusMinus',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        }
      ];
      if (
        (self.modalita === self.CONSTANTS.MODALITA.NUOVA ||
          self.modalita === self.CONSTANTS.MODALITA.MODIFICA) &&
        self.userSrvc.numeroProposteAcquistabili > self.proposteTableData.length
      ) {
        self.portafoglioTableLabel.push({
          field: 'bloccoAcquisti',
          name: $scope.msg('lista.portafoglio.acquista.vendita'),
          width: 120,
          enableFiltering: false,
          cellTemplate:
            '<i class=\'fa fa-plus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni && !gestioneCtrl.waitUser && !row.entity.bloccoAcquisti" uib-tooltip="{{grid.appScope.msg(\'tooltip.acquista\')}}" tooltip-placement="left" ng-click="grid.appScope.acquista({itemPortafoglio: row.entity})"></i>' +
            '<i class=\'fa fa-minus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni" uib-tooltip="{{grid.appScope.msg(\'tooltip.vendi\')}}" tooltip-placement="left" ng-click="grid.appScope.vendita({itemPortafoglio: row.entity})"></i>' +
            '<i class=\'fa fa-exchange fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="!gestioneCtrl.waitUser && !row.entity.bloccoAcquisti && row.entity.mostraBottoni && row.entity.strumento.categoriaStrumento.descrizione === \'Fondo\'" uib-tooltip="{{grid.appScope.msg(\'tooltip.switch\')}}" tooltip-placement="left" ng-click="grid.appScope.cambio({itemPortafoglio: row.entity})"></i>'
        });
      }
    };

    /**
     * @ngdoc method
     * @name initLabelTabellaProposte
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Crea le label e la struttura della tabella delle proposte
     */
    this.initLabelTabellaProposte = function () {
      self.proposteTableLabel = [];
      if (
        self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.VERIFICA_PROPOSTE) ||
        self.userSrvc.isBpa
      ) {
        self.proposteTableLabel.push({
          name: '',
          field: 'segno',
          width: '20',
          enableFiltering: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents">' +
            '   <i class="fa fa-exclamation" style="color: red; font-size: 20px;" ' +
            '       ng-if="grid.appScope.segnalazioniProposte[row.entity.idProposta].length > 0"' +
            '       ng-click="grid.appScope.leggiAlert({idProposta: row.entity.idProposta})" >' +
            '   </i>' +
            '</div>'
        });
      }
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.acq.ven'),
        field: 'segno',
        width: '*',
        enableFiltering: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.proposte.a\') === row.entity.segno">{{grid.appScope.msg(\'lista.proposte.acq\')}}</div>' +
          '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno">{{grid.appScope.msg(\'lista.proposte.ven\')}}</div>' +
          '<div class="ui-grid-cell-contents" ng-ig="grid.appScope.msg(\'lista.proposte.s\') === row.entity.segno">{{grid.appScope.msg(\'lista.proposte.swi\')}}</div>'
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.titolo'),
        field: 'DescrizioneStrumento',
        width: '*',
        enableFiltering: false
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.qta'),
        field: 'quantita',
        width: '*',
        enableFiltering: false
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.ctv.teorico'),
        cellFilter: 'number : 2',
        cellClass: 'right',
        field: 'ctvPrevisto',
        width: '*',
        enableFiltering: false
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.intestatario'),
        field: 'Intestazione',
        width: '*',
        enableFiltering: false
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.rischio.complessita'),
        field: 'rischioComplessita',
        width: '*',
        enableFiltering: false,
        cellClass: 'center',
        cellTemplate:
          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.profiloAppropriatezza >= row.entity.rischioComplessita || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.profiloAppropriatezza >= row.entity.rischioComplessita || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.rischio.emittente'),
        field: 'rischioEmittente',
        width: '*',
        enableFiltering: false,
        cellClass: 'center',
        cellTemplate:
          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.profiloAdeguatezza >= row.entity.rischioEmittente || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.profiloAdeguatezza >= row.entity.rischioEmittente || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.rischio.mercato'),
        field: 'rischioMercato',
        width: '*',
        enableFiltering: false,
        cellClass: 'center',
        cellTemplate:
          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.profiloAdeguatezza >= row.entity.rischioMercato || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.profiloAdeguatezza >= row.entity.rischioMercato || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
      });
      self.proposteTableLabel.push({
        name: $scope.msg('lista.proposte.rischio.liquidita'),
        field: 'rischioLiquidita',
        width: '*',
        enableFiltering: false,
        cellClass: 'center',
        cellTemplate:
          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.rischioLiquidita <= row.entity.orizzonteTemporale || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.rischioLiquidita <= row.entity.orizzonteTemporale || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
      });
      // TODO ESG
      if (self.esgAbilitato) {
        self.proposteTableLabel.push({
          name: $scope.msg('gestione.proposta.esg'),
          field: 'rischioESG',
          width: '*',
          enableFiltering: false,
          cellClass: 'center',
          cellTemplate:
            '<i class="fa fa-circle fa-2x finITable" ng-class="{' +
            "finIGreen : row.entity.controlloEsg.esito === 'OK'," +
            "finIOrange: row.entity.controlloEsg.esito === 'WARNING'," +
            'finIRed: row.entity.controlloEsg.esito === \'KO\'}" aria-hidden="true"></i>'
        });
      }
      //			Se siamo in modalita visualizza faccio visualizzare soltanto la lente di ingarandimento per visualizzare le proposte
      if (self.modalita === self.CONSTANTS.MODALITA.VISUALIZZA) {
        self.proposteTableLabel.push({
          name: $scope.msg('lista.proposte.azione'),
          field: 'azione',
          enableFiltering: false,
          width: 60,
          cellTemplate:
            '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaProposta({proposta: row.entity});"></i>'
        });
      } else {
        if (
          self.raccomandazione.stato ===
          self.CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO
        ) {
          self.proposteTableLabel.push({
            name: $scope.msg('lista.proposte.azione'),
            field: 'azione',
            enableFiltering: false,
            width: 120,
            cellTemplate:
              '<i class="fa fa-pencil fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-click="grid.appScope.modificaProposta({proposta: row.entity});"></i>' +
              '<i class="fa fa-trash fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.elimina\')}}" tooltip-placement="left" ng-click="grid.appScope.eliminaProposta({proposta: row.entity})"></i>' +
              '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaProposta({proposta: row.entity});"></i>'
          });
        } else {
          self.proposteTableLabel.push({
            name: $scope.msg('lista.proposte.azione'),
            field: 'azione',
            enableFiltering: false,
            width: 60,
            cellTemplate:
              '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaProposta({proposta: row.entity});"></i>'
          });
        }
      }
    };
    this.initOrdineDivisoTableLabel = function () {
      self.ordineDivisoTableLabel = [];

      self.ordineDivisoTableLabel.push({
        name: 'IdRichiesta',
        field: 'idRichiesta',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: 'Codice dossier',
        field: 'codiceDossier',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: 'Tipologia',
        field: 'tipologia.descrizione',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: 'Id raccomandazione',
        field: 'idRaccomandazione',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: 'Data inserimento',
        field: 'dataInserimento',
        cellFilter: 'date: "dd/MM/yyyy"',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: 'Stato',
        field: 'stato',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: 'Data Scadenza',
        field: 'dataScadenza',
        cellFilter: 'date: "dd/MM/yyyy"',
        width: '*',
        enableFiltering: false,
        class: 'center'
      });
      self.ordineDivisoTableLabel.push({
        name: $scope.msg('lista.proposte.azione'),
        field: 'azione',
        enableFiltering: false,
        width: 120,
        cellTemplate:
          '<i class="fa fa-pencil fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-if="row.entity.stato === \'INCORSO\'"  ng-click="grid.appScope.inserisciOrdine({propostaOrdine:row.entity});"></i>' +
          '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRichiesta({propostaOrdine:row.entity});"></i>'
      });
    };
    //
    //		--------------------------- INIT CONTROLLER ---------------------------
    //
    /**
     * @ngdoc method
     * @name initConIdRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Inizializza il component tenendo conto della presenza di un id raccomandazione
     */
    this.initConIdRaccomandazione = function () {
      $q.all({
        raccomandazione: self.promiseDettaglioRaccomandazione(),
        portafoglio: self.promiseDatiTabellaPortafoglio(),
        proposte: self.promiseDatiTabellaProposte(),
        filtriStrumento: self.promiseDominioFiltriStrumento(),
        regoleStrumento: self.promiseRegoleStrumento(),
        ordineDiviso: self.promiseGestioneOrdine()
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(response.raccomandazione) ||
              self.messaggiFctr.processaResponse(response.portafoglio) ||
              self.messaggiFctr.processaResponse(response.proposte) ||
              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
              self.messaggiFctr.processaResponse(response.regoleStrumento)
            ) {
              self.spinner.raccomandazione = false;
              self.raccomandazione =
                gestioneRaccomandazioneService.raccomandazione = {};
              self.portafoglioTableData = [];
              self.proposteTableData = [];
              self.filtriStrumento = [];
              self.listaRegoleStrumento = [];
              return;
            }
            self.raccomandazione =
              gestioneRaccomandazioneService.raccomandazione =
                response.raccomandazione.data.result.raccomandazione;
            self.liquiditaAggiuntiva =
              response.raccomandazione.data.result.liquiditaAggiuntiva;
            self.checkStatoPraticaInValutazione();
            self.setAnagraficaFea();
            self.adeguata = response.raccomandazione.data.result.adeguata;
            self.iniziativa = response.raccomandazione.data.result.iniziativa;
            self.portafoglioTableData = response.portafoglio.data.result;
            self.ordineDiviso = response.ordineDiviso.data.result;
            self.initOrdineDivisoTableLabel();
            self.listaRegoleStrumento = response.regoleStrumento.data.result;
            self.checkRegoleStrumento();
            self.proposteTableData = response.proposte.data.result
              ? response.proposte.data.result
              : [];
            self.initLabelTabellaPortafoglio();
            self.initLabelTabellaProposte();
            response.filtriStrumento.data.result.forEach(function (item) {
              self.domain.listaTipologiaStrumento.push({
                label: item.descrizione,
                value: item.codice
              });
            });
            // 				Setto l'inverso della somma dei controvalori delle proposte
            if (self.proposteTableData && self.proposteTableData.length) {
              self.proposteTableData.forEach(function (el) {
                self.totaleCtvTeorico += el.ctvPrevisto;
              });
              self.totaleCtvTeorico *= -1;
            }
            self.checkRightStep();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.raccomandazione);
            self.messaggiFctr.processaResponse(reason.portafoglio);
            self.messaggiFctr.processaResponse(reason.proposte);
            self.messaggiFctr.processaResponse(reason.filtriStrumento);
            self.messaggiFctr.processaResponse(reason.regoleStrumento);
            self.spinner.raccomandazione = false;
            self.raccomandazione =
              gestioneRaccomandazioneService.raccomandazione = {};
            self.portafoglioTableData = [];
            self.proposteTableData = [];
            self.filtriStrumento = [];
            self.listaRegoleStrumento = [];
          }
        )
        .finally(function () {
          self.spinner.portafoglio = false;
          self.spinner.proposte = false;
        });
      if (gestioneRaccomandazioneService.forzaControlli) {
        gestioneRaccomandazioneService.forzaControlli = false;
        self.checkProposte();
      }
    };

    this.checkProposte = function () {
      var defer = $q.defer();
      self.spinner.proposte = true;
      gestioneRaccomandazioneService
        .promiseCheckProposte(
          self.$stateParams.finCodiceRapporto,
          self.$stateParams.finIdRaccomandazione
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.proposte = false;
              defer.reject(false);
              return;
            }
            self.segnalazioni = {};
            var segnalazioniPresenti = false;
            if (response.data.result) {
              response.data.result.forEach(function (segnalazione) {
                self.segnalazioni[segnalazione.idProposta] =
                  segnalazione.segnalazioni;
                if (segnalazione.segnalazioni) {
                  segnalazione.segnalazioni.forEach(function (s) {
                    if (s.livello === 'ERRORE' || s.livello === 'ERROR') {
                      segnalazioniPresenti = true;
                    }
                  });
                }
              });
            }
            self.spinner.proposte = false;
            if (segnalazioniPresenti) {
              self.messaggiFctr.addMessage({
                type: 'E',
                message: 'Segnalazioni presenti'
              });
              defer.reject(false);
              return;
            }
            defer.resolve(true);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.proposte = false;
            defer.reject(false);
          }
        );
      return defer.promise;
    };

    this.leggiAlert = function (idProposta) {
      gestioneRaccomandazioneService.segnalazioniProposta =
        self.segnalazioni[idProposta];
      gestioneRaccomandazioneService.propostaSegnalata = idProposta;

      var modalScontoMassivo = $uibModal.open({
        animation: true,
        templateUrl:
          CONSTANTS.BASE_ROOT +
          CONSTANTS.COMPONENTS_PATH +
          'modalAlertProposte/modalAlertProposte.html',
        size: 'lg',
        controller: 'ModalAlertProposte',
        controllerAs: 'controller'
      });

      modalScontoMassivo.result.then(
        function () {
          gestioneRaccomandazioneService.segnalazioniProposta = [];
          gestioneRaccomandazioneService.propostaSegnalata = null;
        },
        function () {
          gestioneRaccomandazioneService.segnalazioniProposta = [];
          gestioneRaccomandazioneService.propostaSegnalata = null;
        }
      );
    };

    /**
     * @ngdoc method
     * @name initSenzaIdRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Inizializza il component nel caso in cui siamo in una nuova raccomandazione
     */
    this.initSenzaIdRaccomandazione = function () {
      $q.all({
        portafoglio: self.promiseDatiTabellaPortafoglio(),
        filtriStrumento: self.promiseDominioFiltriStrumento(),
        regoleStrumento: self.promiseRegoleStrumento()
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(response.portafoglio) ||
              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
              self.messaggiFctr.processaResponse(response.regoleStrumento)
            ) {
              self.spinner.raccomandazione = false;
              self.filtriStrumento = [];
              self.portafoglioTableData = [];
              self.listaRegoleStrumento = [];
              return;
            }
            response.filtriStrumento.data.result.forEach(function (item) {
              self.domain.listaTipologiaStrumento.push({
                label: item.descrizione,
                value: item.codice
              });
            });
            self.portafoglioTableData = response.portafoglio.data.result;
            self.listaRegoleStrumento = response.regoleStrumento.data.result;
            self.checkRegoleStrumento();
            self.initLabelTabellaPortafoglio();
            self.checkRightStep();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.portafoglio);
            self.messaggiFctr.processaResponse(reason.filtriStrumento);
            self.messaggiFctr.processaResponse(reason.regoleStrumento);
            self.spinner.raccomandazione = false;
            self.listaRegoleStrumento = [];
            self.filtriStrumento = [];
            self.portafoglioTableData = [];
          }
        )
        .finally(function () {
          self.spinner.portafoglio = false;
        });
    };

    //
    //		---------------------------- HELPER METHOD ----------------------------
    //
    /**
     * @ngdoc method
     * @name checkAccettaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Controllo se ho l'abilitazione per poter mostrare il radio button Home Banking
     * ovvero se la funzione ACCETTARACCOMAN è abilitata
     */
    this.checkAccettaRaccomandazione = function () {
      self.userSrvc.abilitazioniPronte.then(function (value) {
        if (value) {
          self.homeBankingAbilitato = self.userSrvc.abilitazioni.some(function (
            abilitazione
          ) {
            return (
              abilitazione.codice.toLowerCase() ===
              self.CONSTANTS.ABILITAZIONI.ACCETTA_RACCOMANDAZIONE.toLowerCase()
            );
          });
        }
      });
    };

    /**
     * @ngdoc method
     * @name getCustomerDossier
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Dicide quale servizio per il customer dossier richiamare
     */
    this.getCustomerDossier = function () {
      // Chiamo il getDossier per inserire le info nel customerdata
      self.promiseCustomerData().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.posizione = {};
            return;
          }
          self.posizione = response.data;
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    this.promiseMifid = function () {
      return $http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          self.$stateParams.finCodiceRapporto +
          '/' +
          self.$stateParams.ndg +
          '/recuperaAlertScadenzaMifid'
      });
    };

    /**
     * @ngdoc method
     * @name checkRegexNota
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Ritorna true se il testo passato rispetta il pattern per le note
     */
    this.checkRegexNota = function (testo) {
      return self.regexTestoNota.test(testo);
    };

    /**
     * @ngdoc method
     * @name checkStatoPraticaInValutazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Se siamo in INCORSO, PRESENTATA o VALUTAZIONE e
     * la pratica è in uno stato diverso da PRESENTATA
     * effettuo il redirect allo stato di visualizzazione
     */
    this.checkStatoPraticaInValutazione = function () {
      var statiRaccomandazioneModificabile = [
        self.CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO,
        self.CONSTANTS.STATO_RACCOMANDAZIONE.PRESENTATA,
        self.CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA,
        self.CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE
      ];
      //			Se lo stato della raccomandazione non è compreso tra quelli soprastanti
      //			e la modalità è valutazione vado in modalità visualizza
      if (
        statiRaccomandazioneModificabile.indexOf(self.raccomandazione.stato) ===
          -1 &&
        self.modalita === self.CONSTANTS.MODALITA.VALUTAZIONE
      ) {
        self.$stateParams.esterno = true;
        self.$state.go(self.visualizzaRaccomandazioneState, self.$stateParams, {
          reload: true
        });
      }
    };

    /**
     * @ngdoc method
     * @name setAnagraficaFea
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Costruisce l'oggetto anagraficaFea
     */
    this.setAnagraficaFea = function () {
      self.anagraficaFea = {
        idAnagrafica: self.raccomandazione.intestatario.idAnagrafica,
        ndg: self.raccomandazione.intestatario.ndg,
        naturaGiuridica: self.raccomandazione.intestatario.formaCostitutiva
      };
    };

    /**
     * @ngdoc method
     * @name checkRegoleStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Gestisce l'array del saldoPortafoglio e decide
     * se mostrare o meno i bottoni di Acquisto, Vendita e Switch
     */
    this.checkRegoleStrumento = function () {
      self.portafoglioTableData.forEach(function (portafoglio) {
        //				Imposta la proprietà mostraBottoniPortafoglio per ciascun saldo in base alle regole dello strumento
        portafoglio['mostraBottoni'] = self.listaRegoleStrumento.some(function (
          regola
        ) {
          var ruolo = false;
          //					Se siamo in brio forkato le logiche cambiano
          if (self.brioSrvc.brioVersion === 'brio-xc') {
            //						Se siamo in filiale effettuo un controllo diverso rispetto a promotore
            if (self.userSrvc.canaleOperativo === 'filialefxc') {
              ruolo =
                !regola.ruolo ||
                regola.ruolo.toLowerCase().trim() === 'filiale';
            } else {
              ruolo =
                !regola.ruolo || regola.ruolo.toLowerCase().trim() === 'brio';
            }
          } else {
            //						Se siamo in brio vecchio controllo su un altro campo
            ruolo =
              !regola.ruolo ||
              regola.ruolo.toLowerCase().trim() ===
                self.userSrvc.user.app.toLowerCase().trim();
          }
          var categoria =
            (!regola.categoria ||
              regola.categoria.toLowerCase().trim() ===
                (portafoglio.strumento.categoriaStrumento.codice
                  ? portafoglio.strumento.categoriaStrumento.codice
                      .toLowerCase()
                      .trim()
                  : '')) &&
            regola.categoria.toLowerCase().trim() !== 'pog';
          var isin =
            !regola.isin ||
            regola.isin.toLowerCase().trim() ===
              portafoglio.strumento.isin.toLowerCase().trim();
          var emittente =
            !regola.emittente ||
            regola.emittente.toLowerCase().trim() ===
              portafoglio.strumento.emittente.toLowerCase().trim();
          return ruolo && categoria && isin && emittente;
        });
      });

      userSrvc.abilitazioniPronte
        .then(function () {
          if (self.mifidAbilitato()) {
            self
              .promiseMifid()
              .then(function (res) {
                if (res.data.result) {
                  self.bloccoAcquisti = res.data.result.some(function (blocco) {
                    return (
                      blocco.statoScadenza === 'SCADUTO' ||
                      blocco.statoScadenza === 'PPROSSIMO_A_SCADERE'
                    );
                  });
                  self.portafoglioTableData.forEach(function (entity) {
                    entity.bloccoAcquisti = self.bloccoAcquisti;
                  });
                }
              })
              .finally(function () {
                self.spinner.ba = false;
              });
          } else {
            self.spinner.ba = false;
          }
        })
        .finally(function () {
          self.waitUser = false;
        });
    };

    /**
     * @ngdoc method
     * @name checkRightStep
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Seleziona il giusto step in cui reindirizzare l'utente
     */
    this.checkRightStep = function () {
      //			Se c'è idRaccomandazione devo gestire lo stato in cui si trova
      if (self.$stateParams.finIdRaccomandazione) {
        if (self.modalita === self.CONSTANTS.MODALITA.VISUALIZZA) {
          //					Chiamo il dossier perché mi serve nel rest del profiloCliente
          self.promiseDettaglioDossier().then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.raccomandazione = false;
                return;
              }
              self.dettaglioDossier = response.data.result;
              self.getEsitoRaccomandazione();
            },
            function (reason) {
              self.spinner.raccomandazione = false;
              self.messaggiFctr.processaResponse(reason);
            }
          );
        } else {
          switch (self.raccomandazione.stato) {
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO:
              sessionStorage.getItem('isFromGestioneOrdine')
                ? self.changeTabMacro(self.TAB_LIST_MACRO[3])
                : self.changeTabMacro(self.TAB_LIST_MACRO[0]);
              sessionStorage.removeItem('isFromGestioneOrdine');
              self.spinner.raccomandazione = false;
              break;
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.ANNULLATA:
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.RIFIUTATA:
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.ACCETTATA:
              sessionStorage.getItem('isFromGestioneOrdine')
                ? self.changeTabMacro(self.TAB_LIST_MACRO[3])
                : self.changeTabMacro(self.TAB_LIST_MACRO[0]);
              sessionStorage.removeItem('isFromGestioneOrdine');
              self.spinner.raccomandazione = false;
              break;
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA:
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE:
              switch (self.raccomandazione.step) {
                case 0:
                  //							Chiamo il dossier perché mi serve nel rest del profiloCliente
                  self.promiseDettaglioDossier().then(
                    function (response) {
                      if (self.messaggiFctr.processaResponse(response)) {
                        self.spinner.raccomandazione = false;
                        return;
                      }
                      self.dettaglioDossier = response.data.result;
                      self.getEsitoRaccomandazione();
                    },
                    function (reason) {
                      self.spinner.raccomandazione = false;
                      self.messaggiFctr.processaResponse(reason);
                    }
                  );
                  break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                  self.spinner.raccomandazione = false;
                  self.changeTabMacro(self.TAB_LIST_MACRO[2]);
                  break;
              }
              break;
            case self.CONSTANTS.STATO_RACCOMANDAZIONE.PRESENTATA:
              self.getDettaglioDossier();
              self.spinner.raccomandazione = false;
              // 							Se filiale entro allo step 1 altrimenti step 0
              if (self.userSrvc.user.app === 'filiale') {
                self.changeTabMacro(self.TAB_LIST_MACRO[1]);
              } else {
                self.changeTabMacro(self.TAB_LIST_MACRO[0]);
              }
              break;
          }
        }
      } else {
        //				Non c'è id quindi sono in creazione
        self.spinner.raccomandazione = false;
        self.changeTabMacro(self.TAB_LIST_MACRO[0]);
      }
    };

    /**
     * @ngdoc method
     * @name getDatiRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Recupera i dati di una raccomandazione e inizializza l'oggetto fea per i documenti
     */
    this.getDatiRaccomandazione = function () {
      self
        .promiseDettaglioRaccomandazione()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.raccomandazione =
              gestioneRaccomandazioneService.raccomandazione =
                response.data.result.raccomandazione;
            self.adeguata = response.data.result.adeguata;
            self.iniziativa = response.data.result.iniziativa;
            self.setAnagraficaFea();
            self.checkRightStep();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.raccomandazione = false;
        });
    };

    /**
     * @ngdoc method
     * @name getEsitoRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Chiama i rest del profiloCliente e multivariata per l'esito della raccomandazione
     */
    this.getEsitoRaccomandazione = function () {
      self.spinner.raccomandazione = true;
      self.spinner.adeguatezza = true;
      $q.all({
        profiloCliente: self.promiseProfiloCliente(),
        multivariata: self.promiseMultivariata()
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(response.profiloCliente) ||
              self.messaggiFctr.processaResponse(response.multivariata)
            ) {
              self.profiloCliente = {};
              self.multivariata = {};
              return;
            }
            self.profiloCliente = response.profiloCliente.data.result;
            self.multivariata = response.multivariata.data.result;

            if (sessionStorage.getItem('isFromGestioneOrdine')) {
              sessionStorage.removeItem('isFromGestioneOrdine');
              self.changeTabMacro(self.TAB_LIST_MACRO[3]);
            } else {
              self.changeTabMacro(self.TAB_LIST_MACRO[1]);
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(response);
            self.profiloCliente = {};
            self.multivariata = {};
          }
        )
        .finally(function () {
          self.spinner.raccomandazione = false;
          self.spinner.adeguatezza = false;
        });
    };
    /**
     * @ngdoc method
     * @name setListaDossier
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Riempie la lista dossier
     */
    this.setListaDossier = function () {
      self
        .promiseListaDossier()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.listaDossier = self.rimuoviDossierNonValidi(
              response.data.result
            );
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.listaDossier = false;
        });
    };

    /**
     * @ngdoc method
     * @name rimuoviDossierNonValidi
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Rimuove dalla lista dei dossier quelli non validi
     * (estinti o non abilitati né a Consulenza né alla gestione degli ordini)
     * @param {Array} - Array completo dei dossier
     * @return {Array} - Array con dossier non validi rimossi
     */
    this.rimuoviDossierNonValidi = function (arrayDossier) {
      return arrayDossier.filter(function (dossier) {
        // Tengo i dossier con dataChiusura a null e quelli che soddisfano la condizione sottostante
        return (
          dossier.dataChiusura === null &&
          dossier.datiMifid.attivitaConsob.some(function (abilitazione) {
            // Controllo che ci sia almeno una delle due abilitazioni
            return (
              abilitazione.codice.trim() === 'B' ||
              abilitazione.codice.trim() === 'D'
            );
          })
        );
      });
    };

    /**
     * @ngdoc method
     * @name getDettaglioDossier
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Riceve il dettalgio del dossier
     */
    this.getDettaglioDossier = function () {
      self.spinner.listaDossier = true;
      self.promiseDettaglioDossier().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.listaDossier = false;
            return;
          }
          self.dettaglioDossier = response.data.result;
          self.getEsitoRaccomandazione();
          self.checkAbilitazioniOrdini();
        },
        function (reason) {
          self.spinner.listaDossier = false;
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name checkAbilitazioniOrdini
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Verifica che il dossier sia abilitato alla raccolta degli ordini
     */
    this.checkAbilitazioniOrdini = function () {
      //			Verifica che l'array attivitaConsob sia abilitato alla raccolta degli ordini
      self.dossierAbilitato =
        self.dettaglioDossier.datiMifid.attivitaConsob.some(function (
          abilitazione
        ) {
          return (
            abilitazione.codice.trim() === 'B' ||
            abilitazione.codice.trim() === 'D'
          );
        });
      if (self.dossierAbilitato === false) {
        self.setListaDossier();
      } else {
        self.spinner.listaDossier = false;
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Riceve la classe appropriata per la colorazione del macro
     * @param {Number} currentTabIndex - L'indice del tab corrente
     * @return {String} - Il nome della classe per settare il colore del macro
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }
      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }
      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
     * @param {Number} currentTabIndex - L'indice del tab corrente
     * @return {String} - Il nome della classe per settare il colore del macro
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }
      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }
      return 'progress-next-read';
    };
    this.inserisciOrdine = function (propostaOrdine) {
      self.$stateParams.finIdRaccomandazione = propostaOrdine.idRaccomandazione;
      self.$stateParams.finIdRichiesta = propostaOrdine.idRichiesta;
      if (self.modalita === 'visualizza') {
        sessionStorage.setItem('isFromGestioneOrdine', true);
        sessionStorage.setItem('isVisualizza', true);
      }
      if (self.modalita === 'modifica') {
        sessionStorage.setItem('isFromGestioneOrdine', true);
        sessionStorage.setItem('isModifica', true);
      }
      self.$state.go('gestionerichiesta', self.$stateParams);
    };
    this.visualizzaRichiesta = function (propostaOrdine) {
      self.$stateParams.finIdRaccomandazione = propostaOrdine.idRaccomandazione;
      self.$stateParams.finIdRichiesta = propostaOrdine.idRichiesta;
      sessionStorage.setItem('isFromGestioneOrdine', true);
      sessionStorage.setItem('isVisualizza', true);
      self.$state.go('visualizzarichiesta', self.$stateParams);
    };
    //
    //		--------------------------- BUTTONS METHOD ----------------------------
    //

    this.apriMassivo = function () {
      var modalScontoMassivo = $uibModal.open({
        animation: true,
        templateUrl:
          CONSTANTS.BASE_ROOT +
          CONSTANTS.COMPONENTS_PATH +
          'modalScontoMassivo/modalScontoMassivo.html',
        size: 'xl',
        controller: 'ModalScontoMassivoController',
        controllerAs: 'controller'
      });

      modalScontoMassivo.result.then(
        function (res) {},
        function (reason) {}
      );
    };

    /**
     * @ngdoc method
     * @name changeTabMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Setta il tab attuale
     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
     */
    this.changeTabMacro = function (tab) {
      self.currentTabMacro = tab;
      self.messaggiSrvc.reset();
    };

    /**
     * @ngdoc method
     * @name avanti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Avanza allo step successivo
     */
    this.avanti = function () {
      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
    };

    /**
     * @ngdoc method
     * @name indietro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Ritorna allo step precedente
     */
    this.indietro = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      switch (self.brioSrvc.brioVersion) {
        case 'brio2':
        case 'brio3':
          self.$stateParams.idAnagrafica = self.anagraficaFea.idAnagrafica;
          self.$state.go('schedaCliente', self.$stateParams);
          break;
        case 'brio-xc':
          var parametri = [
            {
              chiave: 'idAnagrafica',
              valore: self.anagraficaFea.idAnagrafica
            }
          ];
          self.brioSrvc.goTo(
            'scrivaniautente',
            'home.schedacliente',
            parametri
          );
          break;
      }
    };

    /**
     * @ngdoc method
     * @name esci
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Se è presente il parametro esterno torna su Brio altrimenti torna al saldoDossier
     */
    this.esci = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      if (self.$stateParams.esterno === 'true') {
        switch (self.brioSrvc.brioVersion) {
          case 'brio2':
          case 'brio3':
            self.$stateParams.idAnagrafica = self.anagraficaFea.idAnagrafica;
            self.$state.go('schedaCliente', self.$stateParams);
            break;
          case 'brio-xc':
            var parametri = [
              //	    				{
              //	    					chiave: 'idAnagrafica',
              //	    					valore: self.anagrafica.idAnagrafica
              //	    				}
              {
                chiave: 'ndg',
                valore: self.$stateParams.ndg
              }
            ];
            self.brioSrvc.goTo(
              'scrivaniautente',
              'home.schedacliente',
              parametri
            );
            break;
        }
      } else {
        // self.$window.history.back();
        if (
          sessionStorage.getItem('isFromSchedaDossier') &&
          sessionStorage.getItem('isFromSchedaDossier') === 'true'
        ) {
          sessionStorage.removeItem('isFromSchedaDossier');
          self.$state.go('schedaDossier', self.$stateParams);
        } else {
          self.$state.go(self.saldoDossierState, self.$stateParams);
        }
      }
    };

    /**
     * @ngdoc method
     * @name nuovaProposta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Va nello stato di creazione delle proposte
     */
    this.nuovaProposta = function () {
      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
      if (!!self.iniziativa) {
        self.$stateParams.finIniziativa = self.iniziativa;
      }
      self.$state.go(self.nuovaPropostaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name modificaProposta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Va nello stato di gestione della proposta
     * @param {Object} proposta - Oggetto proposta da modificare
     */
    this.modificaProposta = function (proposta) {
      self.$stateParams.acqven = proposta.segno;
      self.$stateParams.finIdProposta = proposta.idProposta;
      self.$stateParams.finCodiceStrumento = proposta.strumento.trim();
      self.$state.go(self.modificaPropostaState, self.$stateParams);
    };

    /**
     * @method
     * @name visualizzaProposta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Entra nello stato di visualizzazione di una proposta
     * @param {Object} proposta - Oggetto proposta da visualizzare
     */
    this.visualizzaProposta = function (proposta) {
      self.$stateParams.acqven = proposta.segno;
      self.$stateParams.finIdProposta = proposta.idProposta;
      self.$stateParams.finCodiceStrumento = proposta.strumento.trim();
      self.$state.go(self.visualizzaPropostaState, $stateParams);
    };

    /**
     * @ngdoc method
     * @name acquista
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Entra nello stato nuova proposta con modalita acquisto
     */
    this.acquista = function (itemPortafoglio) {
      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
      self.$stateParams.finCodiceStrumento =
        itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaPropostaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name vendita
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Entra nello stato nuova proposta con modalita vendita
     */
    this.vendita = function (itemPortafoglio) {
      self.$stateParams.acqven = $scope.msg('lista.proposte.d');
      self.$stateParams.finCodiceStrumento =
        itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaPropostaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name cambio
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Entra nello stato di una nuova proposta
     * ma per effettuare uno switch su un altro portafoglio
     */
    this.cambio = function (itemPortafoglio) {
      self.$stateParams.acqven = $scope.msg('lista.proposte.s');
      self.$stateParams.finCodiceStrumento =
        itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaPropostaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name accetta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Accetta la raccomandazione
     */
    this.accetta = function () {
      self.spinner.raccomandazione = true;
      self
        .promiseAccettaRaccomandazione()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            if (response.data.result && response.data.result.idPratica) {
              self.$stateParams.finIdRichiesta = response.data.result.idPratica;
              self.$stateParams.finServizio = 1;
              self.$state.go(self.gestioneRichiestaState, self.$stateParams);
            } else {
              self.$state.go(self.saldoDossierState, self.$stateParams);
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.raccomandazione = false;
        });
    };

    /**
     * @ngdoc method
     * @name rifiuta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Rifiuta la raccomandazione
     */
    this.rifiuta = function () {
      self.promiseRifiutaRaccomandazione().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          // Inserire la rotta per uscire da consulenza
          self.$state.go(self.saldoDossierState, self.$stateParams);
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name revisiona
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Manda in revisione la raccomandazione
     */
    this.revisiona = function () {
      self.promiseRevisionaRaccomandazione().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          // Inserire la rotta per uscire da consulenza
          self.$state.go(self.saldoDossierState, self.$stateParams);
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name elimina
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Elimina la proposta dalla lista e se l'operazione va
     * a buon fine rieffettua la chiamata per la lista delle proposte
     * @param {Number} idProposta - L'id della proposta da eliminare
     */
    this.eliminaProposta = function (proposta) {
      self.spinner.listaProposte = true;
      self.promiseEliminaProposta(proposta.idProposta).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.listaProposte = false;
            return;
          }
          if (response.data.result) {
            self.$state.go(self.$state.current.name, self.$stateParams, {
              reload: true
            });
          } else {
            self.spinner.listaProposte = false;
          }
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.listaProposte = false;
        }
      );
    };

    /**
     * @ngdoc method
     * @name consolida
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Consolida la raccomandazione
     */
    this.consolida = function () {
      if (!self.liquiditaAggiuntiva) {
        self.consolidaRaccomandazione();
        return;
      }
      self.spinner.raccomandazione = true;
      self.promiseAddLiquiditaAggiuntiva().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.raccomandazione = false;
            return;
          }
          self.consolidaRaccomandazione();
        },
        function () {
          self.spinner.raccomandazione = false;
        }
      );
    };

    this.consolidaRaccomandazione = function () {
      self.spinner.raccomandazione = true;
      var promise =
        self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.VERIFICA_PROPOSTE) ||
        self.userSrvc.isBpa
          ? self.checkProposte()
          : $q.when(true);

      promise.then(
        function (value) {
          if (value) {
            self.promiseConsolidaRaccomandazione().then(
              function (response) {
                if (self.messaggiFctr.processaResponse(response)) {
                  self.spinner.raccomandazione = false;
                  return;
                }
                self.getDatiRaccomandazione();
              },
              function (reason) {
                self.messaggiFctr.processaResponse(reason);
                self.spinner.raccomandazione = false;
              }
            );
          }
        },
        function () {
          self.spinner.raccomandazione = false;
        }
      );
    };
    /**
     *
     * @name addLiquiditaAggiuntiva
     * @description Aggiunge la liquidita aggiuntiva
     */
    this.addLiquiditaAggiuntiva = function () {
      self.spinner.raccomandazione = true;
      if (
        this.tmpLiquiditaAggiuntiva === undefined ||
        this.tmpLiquiditaAggiuntiva === null
      ) {
        console.log('Liquidita minore di zero');
        self.spinner.raccomandazione = false;
        this.tmpLiquiditaAggiuntiva = 0;
        return;
      }
      this.liquiditaAggiuntiva = 0;
      this.liquiditaAggiuntiva += this.tmpLiquiditaAggiuntiva;
      this.tmpLiquiditaAggiuntiva = 0;
      this.promiseAddLiquiditaAggiuntiva().then(function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          self.spinner.raccomandazione = false;
          return;
        }
        self.initConIdRaccomandazione();
        self.spinner.raccomandazione = false;
      });
      $('#liquiditaAggiuntivaModal').modal('hide');
    };
    /**
     * @ngdoc method
     * @name proseguiToDocumenti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Chiama il servizio che cambia di stato la pratica
     */
    this.proseguiToDocumenti = function () {
      self.spinner.raccomandazione = true;
      self.promiseEsitoRaccomandazione().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.raccomandazione = false;
            return;
          }
          self.getDatiRaccomandazione();
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.raccomandazione = false;
        }
      );
    };
    /**
     * @ngdoc method
     * @name termina
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Termina la gestione della raccomandazione
     */
    this.termina = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      self.spinner.raccomandazione = true;
      self
        .promiseTerminaRaccomandazione()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.raccomandazione = false;
              return;
            }
            if (response.data.result && self.richiestaProcessione === 'N') {
              self.$state.go('saldodossier', self.$stateParams);
              self.spinner.raccomandazione = false;
            }
            if (response.data.result === true) {
              self.promiseGestioneOrdine().then(function (response) {
                if (self.messaggiFctr.processaResponse(response)) {
                  self.spinner.raccomandazione = false;
                  return;
                }
                if (response.data.result && response.data.result.length > 1) {
                  self.ordineDiviso = response.data.result;
                  self.ordineDiviso.forEach(function (ordine) {
                    ordine.modalita = self.modalita;
                  });
                  self.initOrdineDivisoTableLabel();
                  self.spinner.raccomandazione = false;
                  self.avanti();
                } else if (
                  response.data.result &&
                  response.data.result.length === 1
                ) {
                  self.$stateParams.finIdRichiesta =
                    response.data.result[0].idRichiesta;
                  self.$state.go('gestionerichiesta', self.$stateParams);
                }
              });
            } else {
              self.$state.go('saldodossier', self.$stateParams);
            }
            /* if (response.data.result && response.data.result.idPratica) {
                                                                self.$stateParams.finIdRichiesta =
                                                                  response.data.result.idPratica;
                                                                self.$stateParams.finServizio = 1;
                                                                self.$state.go(self.gestioneRichiestaState, self.$stateParams);
                                                              } else {
                                                                self.$state.go(self.saldoDossierState, self.$stateParams);
                                                              } */
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.raccomandazione = false;
        });
    };

    if (self.deskSrvc.isDesk) {
      labelSrvc.labelsPronte.then(function () {
        self.deskSrvc.aggiungiEntry(
          labelSrvc.getLabel('gestione.raccomandazione')
        );
      });
    }
  };
  GestioneRaccomandazioneCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$location',
    '$uibModal',
    'FinMessaggiFctr',
    'FinLabelSrvc',
    'FIN_CONSTANTS',
    '$window',
    'gestioneRaccomandazioneService',
    'uiGridConstants',
    'FinUserSrvc',
    'CblMessageSrvc',
    'FinBrioSrvc',
    'FinDeskSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'gestioneRaccomandazione/gestioneRaccomandazione.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var GestioneRaccomandazioneComponent = {
    bindings: {
      nuovaPropostaState: '@',
      modificaPropostaState: '@',
      visualizzaPropostaState: '@',
      gestioneRichiestaState: '@',
      saldoDossierState: '@',
      visualizzaRaccomandazioneState: '@',
      modalita: '@'
    },
    controller: GestioneRaccomandazioneCtrl,
    controllerAs: 'gestioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component(
      'finanzaGestioneRaccomandazione',
      GestioneRaccomandazioneComponent
    );
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/gestioneRaccomandazione/gestioneRaccomandazione.cmpt.js
 ** module id = 17
 ** module chunks = 0 1 2
 **/